export const SYSTEM_NOTICE_SAVE = 'SYSTEM_NOTICE_SAVE';
export const SYSTEM_NOTICE_CLEAR = 'SYSTEM_NOTICE_CLEAR';